import { ApiType } from "@gymflow/common";
import { QueryKey } from "@tanstack/react-query";

export const eventOccurrenceAsMemberQueryKeys = {
  all: () => ["memberApiEventOccurrence", "oldApi"] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }>) =>
    [...eventOccurrenceAsMemberQueryKeys.all(), { filters }] as QueryKey,
  findById: (id?: number) =>
    [...eventOccurrenceAsMemberQueryKeys.all(), id] as QueryKey,
  eventOccurrences: (filters?: Readonly<{ [k: string]: any }>) => {
    if (filters) {
      return [
        ...eventOccurrenceAsMemberQueryKeys.all(),
        "eventOccurrences",
        { filters },
      ] as QueryKey;
    } else {
      return [
        ...eventOccurrenceAsMemberQueryKeys.all(),
        "eventOccurrences",
      ] as QueryKey;
    }
  },
  eventOccurrencesInfiniteQuery: (filters?: Readonly<{ [k: string]: any }>) => {
    if (filters) {
      return [
        ...eventOccurrenceAsMemberQueryKeys.all(),
        "eventOccurrencesInfiniteQuery",
        { filters },
      ] as QueryKey;
    } else {
      return [
        ...eventOccurrenceAsMemberQueryKeys.all(),
        "eventOccurrencesInfiniteQuery",
      ] as QueryKey;
    }
  },
  eventRsvpUpcoming: (
    filters: Readonly<
      Parameters<
        ApiType["customerOccurrenceApi"]["eventRsvpUpcoming"]
      >[0]["filters"]
    >,
  ) =>
    [
      ...eventOccurrenceAsMemberQueryKeys.all(),
      "eventRsvpUpcoming",
      { filters },
    ] as QueryKey,
  eventRsvpPast: (
    filters: Readonly<
      Parameters<
        ApiType["customerOccurrenceApi"]["eventRsvpPast"]
      >[0]["filters"]
    >,
  ) =>
    [
      ...eventOccurrenceAsMemberQueryKeys.all(),
      "eventRsvpPast",
      { filters },
    ] as QueryKey,
};
